import { render } from "./AvailRestrictRules.vue?vue&type=template&id=369a34c9&scoped=true"
import script from "./AvailRestrictRules.vue?vue&type=script&lang=js"
export * from "./AvailRestrictRules.vue?vue&type=script&lang=js"

import "./AvailRestrictRules.vue?vue&type=style&index=0&id=369a34c9&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-369a34c9"]])

export default __exports__